var map = {
	"./die-10-numbered.png": 3321,
	"./die-12-numbered.png": 3661,
	"./die-20-numbered.png": 6874,
	"./die-4-numbered.png": 5915,
	"./die-6-numbered.png": 7685,
	"./die-8-numbered.png": 7251
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6961;